import apiFetch from "@wordpress/api-fetch";

const path = "/corksy/v1/settings";

class SettingsService {
  async get() {
    const settings = await apiFetch({ path });
    sessionStorage.setItem("settings", JSON.stringify(settings[0]));
    return settings.length ? settings[0] : {};
  }
}

export default new SettingsService();
